import React from "react";
import { connect } from "react-redux";
import StandardOrder from "./StandardOrder";
import AppStepper from "./AppStepper";
import { withRouter } from "react-router-dom";
import * as fuiRedux from "../../redux/fui/index";
import PropTypes from "prop-types";
import PlatformLicenseStepper from "./PlatformLicenseStepper";

/**
 * Fui page for platforms
 * @author Xiao Luo
 * @version 1.0
 * @see Used in component: FulfilmentUI
 */
const FuiHomePage = ({
  match: {
    params: { routeName },
  },
  classes,
}) => {
  // create function that guide to selected products
  const renderProduct = () => {
    const assetData = [
      "managedPlatform",
      "dedicatedPlatform",
      "utkmPlatform",
      "genWizardPlatform",
      "adPlatform",
      "windowsProvisioningPlatform",
      "plainInstance",
      "plainInstanceMcc",
      "pamInstance",
      "automaticTicketResolver",
      "eventOpsPlatform",
      "quasarpp",
      "stormseer",
      "splunkClusterPlatform",
      "stack360",
      "onPremiseService",
      "automationAnywhereLicenses",
      "serviceIntegrator",
      "ec2ClaudeCode",
      "agentMesh",
      "cia",
      "pamktka",
      "dedicatedvirtualnetworksetup",
      "BedrockPlatform",
      "genwizardAgent",
      "ticketAnalysis",
      "noTouch",
      "reverseEngineering"
    ];
        
    if (routeName === undefined) {
      return <StandardOrder />;
    }
    
    if (assetData.includes(routeName)) {
      return <PlatformLicenseStepper classes={classes} />;
    } else {
      return <AppStepper classes={classes} />;
    }
  };
  return <div>{renderProduct()}</div>;
};

const MSTP = (state) => ({
  listenerClearLocalData: state.fui.listenerClearLocalData,
});
FuiHomePage.propTypes = {
  /**
   * Match property of route library
   */
  match: PropTypes.object,
  /**
   *
   */
  clearLocalComponentData: PropTypes.func,
  /**
   * Redux function to update an instance.
   */
  updateASelectedInstance: PropTypes.func,
};

export default withRouter(
  connect(MSTP, { updateASelectedInstance: fuiRedux.updateASelectedInstance })(
    FuiHomePage
  )
);
